export enum POST_JOB_FLOW {
  EXTRA_BID = 'extra-bid',
  SINGLE_BID = 'single-bid',
  DIRECT_CONTACT = 'direct-contact',
  LEGACY = 'legacy',
  MULTI_BID = 'multi-bid',
  LEGACY_FALLBACK = 'legacy-fallback',
  FASTLANE_SINGLE = 'fastlane-single',
  FASTLANE_MULTI = 'fastlane-multi'
}

export enum POST_JOB_FLOW_STATE {
  EXTRA_BIDS_NOT_FOUND = 'extra-bids-not-found',
  EXTRA_BIDS_HAS_FOUND = 'extra-bids-has-found'
}
